import React from 'react';
import { Backing } from './Backing';
import { ForWhom } from './ForWhom';
import { WhatsIncluded } from './WhatsIncluded';
import { Offer } from './Offer';
import { Bonuses } from './Bonuses';
import { Passport } from './Passport';
import { Testimonials } from './Testimonials';
import { Faq } from './Faq';
import { FinalCTA } from './FinalCTA';

/** Everything after the hero, loaded as a deferred chunk. */
export function BelowFold() {
  return <>
      <Backing data-id="element-24" data-mp="8nccfzbw6nh4" />
      <ForWhom data-id="element-25" data-mp="8n42ogb2fya5" />
      <WhatsIncluded data-id="element-26" data-mp="3qlybhjne1yc" />
      {/* Main offer leads straight into the bonuses it unlocks. */}
      <Offer data-id="element-27" data-mp="iezy1jlrpaao" />
      <Bonuses data-id="element-28" data-mp="ifrx54ekpq5p" />
      <Passport data-id="element-29" data-mp="igbccdcua0g1" />
      <Testimonials data-id="element-30" data-mp="igt715jus6lu" />
      <Faq data-id="element-31" data-mp="ihcqiqp5j31z" />
      <div id="final-cta" data-id="element-32" data-mp="dojl00luzqou">
        <FinalCTA data-id="element-33" data-mp="do05eqjoledz" />
      </div>
    </>;
}